export default "__VITE_ASSET__Byf7bXiJ__"